export const applicationUrls: any = {
  localhost: {
    dusGatewayUrl: 'https://dusaccess--Intsit.sandbox.my.salesforce.com/',
    dusDocwayUrl: 'http://dwv-ezu-a029:8080/D2/#d2',
    dusRiskwayUrl: 'https://mfrw.cdxms.devl-etss.aws.fanniemae.com/',
    dus360Url: 'https://dus360p1.mfamp.mfbu.devl.intgfanniemae.com',
    dusNavigateUrl: 'https://dusnavigatedev.prod.acquia-sites.com/',
    LogoutUrlInternal: 'https://fmsso-devl.fanniemae.com/idp/startSLO.ping?TargetResource=https://fnma.sharepoint.com/sites/FannieMaeHomeSite',
    LogoutUrlExternal: 'https://fmsso-devl.fanniemae.com/idp/startSLO.ping?TargetResource=https://www.fanniemae.com/multifamily',
    userDetailsPath: '/userdetails',
    loginRedirectPath: '/api/?cdxRedirectPath=/',
    localDevRoles: ['SG-IC1-NONPROD-ADMIN-ROLE'],
    // Selects which dev-public/dev-users.json entry (matched by its `label` field) to use as
    // the local-dev identity in initializeUserDetailsAndRedirectToLogin(). Change this to switch
    // which local user (e.g. an external Lender) the app runs as on localhost. Falls back to the
    // first catalog entry if the label is unset or doesn't match any entry.
    // Available labels in dev-public/dev-users.json:
    //   'Testuser - Internal Analyst'
    //   'Testuser - Internal Admin'
    //   'Capital One - External Lender Admin'
    //   'JP Morgan - External Lender Admin'
    //   'JP Morgan - External Lender'
    //   'Citi Bank - External Lender'
    //   'Arbor - External Lender'
    //localDevUserLabel: 'Testuser - Internal Analyst',
    //localDevUserLabel: 'Citi Bank - External Lender',
    localDevUserLabel: 'Testuser - Internal Admin',
    //localDevUserLabel: 'JP Morgan - External Lender',
    echoUrl: '',
    link1: '',
    ldiUrl: 'https://mfdf.mfdf.mfbu.devl.intgfanniemae.com/'
  },
  'mfrm.cdxms.devl-etss.aws.fanniemae.com': {
    dusGatewayUrl: 'https://dusaccess--Intsit.sandbox.my.salesforce.com/',
    dusDocwayUrl: 'http://dwv-ezu-a029:8080/D2/#d2',
    dusRiskwayUrl: 'https://mfrw.cdxms.devl-etss.aws.fanniemae.com/',
    dus360Url: 'https://dus360p1.mfamp.mfbu.devl.intgfanniemae.com',
    dusNavigateUrl: 'https://dusnavigatedev.prod.acquia-sites.com/',
    LogoutUrlInternal: 'https://fmsso-devl.fanniemae.com/idp/startSLO.ping?TargetResource=https://fnma.sharepoint.com/sites/FannieMaeHomeSite',
    LogoutUrlExternal: 'https://fmsso-devl.fanniemae.com/idp/startSLO.ping?TargetResource=https://www.fanniemae.com/multifamily',
    userDetailsPath: '/userdetails',
    loginRedirectPath: '/api/?cdxRedirectPath=/',
    echoUrl: '',
    link1: '',
    ldiUrl: 'https://mfdf.mfdf.mfbu.devl.intgfanniemae.com/'
  },
  'ic1.mfrm.mfbu.devl.intgfanniemae.com': {
    dusGatewayUrl: 'https://dusaccess--Intsit.sandbox.my.salesforce.com/',
    dusDocwayUrl: 'http://dwv-ezu-a029:8080/D2/#d2',
    dusRiskwayUrl: 'https://mfrw.cdxms.devl-etss.aws.fanniemae.com/',
    dus360Url: 'https://dus360p1.mfamp.mfbu.devl.intgfanniemae.com',
    dusNavigateUrl: 'https://dusnavigatedev.prod.acquia-sites.com/',
    LogoutUrlInternal: 'https://fmsso-devl.fanniemae.com/idp/startSLO.ping?TargetResource=https://fnma.sharepoint.com/sites/FannieMaeHomeSite',
    LogoutUrlExternal: 'https://fmsso-devl.fanniemae.com/idp/startSLO.ping?TargetResource=https://www.fanniemae.com/multifamily',
    userDetailsPath: '/userdetails',
    loginRedirectPath: '/api/?cdxRedirectPath=/',
    echoUrl: '',
    link1: '',
    ldiUrl: 'https://mfdf.mfdf.mfbu.devl.intgfanniemae.com/'
  },
  'mfrm.cdxms.test-etss.aws.fanniemae.com': {
    dusGatewayUrl: 'https://dusaccess--Intsit.sandbox.my.salesforce.com/',
    dusDocwayUrl: 'http://dwv-ezu-a029:8080/D2/#d2',
    dusRiskwayUrl: 'https://mfrw.cdxms.test-etss.aws.fanniemae.com/',
    dus360Url: 'https://dus360p1.mfamp.mfbu.test.intgfanniemae.com',
    dusNavigateUrl: 'https://dusnavigatedev.prod.acquia-sites.com/',
    LogoutUrlInternal: 'https://fmsso-test.fanniemae.com/idp/startSLO.ping?TargetResource=https://fnma.sharepoint.com/sites/FannieMaeHomeSite',
    LogoutUrlExternal: 'https://fmsso-test.fanniemae.com/idp/startSLO.ping?TargetResource=https://www.fanniemae.com/multifamily',
    userDetailsPath: '/userdetails',
    loginRedirectPath: '/api/?cdxRedirectPath=/',
    echoUrl: '',
    link1: '',
    ldiUrl: 'https://mfdf.mfdf.mfbu.test.intgfanniemae.com/'
  },
  'ic1.mfrm.mfbu.test.intgfanniemae.com': {
    dusGatewayUrl: 'https://dusaccess--Intsit.sandbox.my.salesforce.com/',
    dusDocwayUrl: 'http://dwv-ezu-a029:8080/D2/#d2',
    dusRiskwayUrl: 'https://mfrw.cdxms.test-etss.aws.fanniemae.com/',
    dus360Url: 'https://dus360p1.mfamp.mfbu.test.intgfanniemae.com',
    dusNavigateUrl: 'https://dusnavigatedev.prod.acquia-sites.com/',
    LogoutUrlInternal: 'https://fmsso-test.fanniemae.com/idp/startSLO.ping?TargetResource=https://fnma.sharepoint.com/sites/FannieMaeHomeSite',
    LogoutUrlExternal: 'https://fmsso-test.fanniemae.com/idp/startSLO.ping?TargetResource=https://www.fanniemae.com/multifamily',
    userDetailsPath: '/userdetails',
    loginRedirectPath: '/api/?cdxRedirectPath=/',
    echoUrl: '',
    link1: '',
    ldiUrl: 'https://mfdf.mfdf.mfbu.test.intgfanniemae.com/'
  },
  'mfrm.cdxms.acpt-etss.aws.fanniemae.com': {
    dusGatewayUrl: 'https://dusaccess--Intsit.sandbox.my.salesforce.com/',
    dusDocwayUrl: 'http://dwv-ezu-a029:8080/D2/#d2',
    dusRiskwayUrl: 'https://mfrw.cdxms.acpt-etss.aws.fanniemae.com/',
    dus360Url: 'https://dus360p1.mfamp.mfbu.acpt.intgfanniemae.com',
    dusNavigateUrl: 'https://dusnavigatedev.prod.acquia-sites.com/',
    LogoutUrlInternal: 'https://fmsso-acpt.fanniemae.com/idp/startSLO.ping?TargetResource=https://fnma.sharepoint.com/sites/FannieMaeHomeSite',
    LogoutUrlExternal: 'https://fmsso-acpt.fanniemae.com/idp/startSLO.ping?TargetResource=https://www.fanniemae.com/multifamily',
    userDetailsPath: '/userdetails',
    loginRedirectPath: '/api/?cdxRedirectPath=/',
    echoUrl: '',
    link1: '',
    ldiUrl: 'https://mfdf.mfdf.mfbu.acpt.intgfanniemae.com/'
  },
  'ic1.mfrm.mfbu.acpt.intgfanniemae.com': {
    dusGatewayUrl: 'https://dusaccess--Intsit.sandbox.my.salesforce.com/',
    dusDocwayUrl: 'http://dwv-ezu-a029:8080/D2/#d2',    dusRiskwayUrl: 'https://mfrw.cdxms.acpt-etss.aws.fanniemae.com/',
    dus360Url: 'https://dus360p1.mfamp.mfbu.acpt.intgfanniemae.com',
    dusNavigateUrl: 'https://dusnavigatedev.prod.acquia-sites.com/',
    LogoutUrlInternal: 'https://fmsso-acpt.fanniemae.com/idp/startSLO.ping?TargetResource=https://fnma.sharepoint.com/sites/FannieMaeHomeSite',
    LogoutUrlExternal: 'https://fmsso-acpt.fanniemae.com/idp/startSLO.ping?TargetResource=https://www.fanniemae.com/multifamily',
    userDetailsPath: '/userdetails',
    loginRedirectPath: '/api/?cdxRedirectPath=/',
    echoUrl: '',
    link1: '',
    ldiUrl: 'https://mfdf.mfdf.mfbu.acpt.intgfanniemae.com/'
  },
  'mfrm.acptfanniemae.com' : {
    dusGatewayUrl: 'https://dusaccess--Intsit.sandbox.my.salesforce.com/',
    dusDocwayUrl: 'http://dwv-ezu-a029:8080/D2/#d2',
    dusDocWayUrl: 'http://dwv-ezu-a029:8080/D2/#d2',
    dusRiskwayUrl: 'https://mfrw.cdxms.acpt-etss.aws.fanniemae.com/',
    dus360Url: 'https://dus360p1.mfamp.mfbu.acpt.intgfanniemae.com',
    dusNavigateUrl: 'https://dusnavigatedev.prod.acquia-sites.com/',
    LogoutUrlInternal: 'https://fmsso-acpt.fanniemae.com/idp/startSLO.ping?TargetResource=https://fnma.sharepoint.com/sites/FannieMaeHomeSite',
    LogoutUrlExternal: 'https://fmsso-acpt.fanniemae.com/idp/startSLO.ping?TargetResource=https://www.fanniemae.com/multifamily',
    userDetailsPath: '/userdetails',
    loginRedirectPath: '/api/?cdxRedirectPath=/',
    echoUrl: '',
    link1: '',
    ldiUrl: 'https://mfdf.mfdf.mfbu.acpt.intgfanniemae.com/'
  },
  'mfrm.fanniemae.com' : {
    dusGatewayUrl: 'https://dusaccess--Intsit.sandbox.my.salesforce.com/',
    dusDocwayUrl: 'http://dwv-ezu-a029:8080/D2/#d2',
    dusDocWayUrl: 'http://dwv-ezu-a029:8080/D2/#d2',
    dusRiskwayUrl: 'https://mfriskway.fanniemae.com/',
    dus360Url: 'https://dus360p1.mfamp.mfbu.prod.intgfanniemae.com',
    dusNavigateUrl: 'https://dusnavigatedev.prod.acquia-sites.com/',
    LogoutUrlInternal: 'https://fmsso.fanniemae.com/idp/startSLO.ping?TargetResource=https://fnma.sharepoint.com/sites/FannieMaeHomeSite',
    LogoutUrlExternal: 'https://fmsso.fanniemae.com/idp/startSLO.ping?TargetResource=https://www.fanniemae.com/multifamily',
    userDetailsPath: '/userdetails',
    loginRedirectPath: '/api/?cdxRedirectPath=/',
    echoUrl: '',
    link1: '',
    ldiUrl: 'https://hno.mfdf.mfbu.prod.fanniemae.com/'
  }
};

export const apiEndpoints: Record<string, { loginUrl: string; serverWithApiUrl: string; redirectUri: string; env: string }> = {
  localhost: {
    loginUrl: 'http://localhost:8000/',
    serverWithApiUrl: 'http://localhost:8000/api/',
    redirectUri: '&redirect_uri=http://localhost:8000',
    env: 'LOCAL'
  },
  'mfrm.cdxms.devl-etss.aws.fanniemae.com': {
    loginUrl: 'https://mfrm.cdxms.devl-etss.aws.fanniemae.com/api/?cdxRedirectPath=/',
    serverWithApiUrl: 'https://mfrm.cdxms.devl-etss.aws.fanniemae.com/api/',
    redirectUri: '',
    env: 'DEVL'
  },
  'ic1.mfrm.mfbu.devl.intgfanniemae.com': {
    loginUrl: 'https://ic1.mfrm.mfbu.devl.intgfanniemae.com/api/?cdxRedirectPath=/',
    serverWithApiUrl: 'https://ic1.mfrm.mfbu.devl.intgfanniemae.com/api/',
    redirectUri: '',
    env: 'DEVL'
  },
  'mfrm.cdxms.test-etss.aws.fanniemae.com': {
    loginUrl: 'https://mfrm.cdxms.test-etss.aws.fanniemae.com/api/?cdxRedirectPath=/',
    serverWithApiUrl: 'https://mfrm.cdxms.test-etss.aws.fanniemae.com/api/',
    redirectUri: '',
    env: 'TEST'
  },
  'ic1.mfrm.mfbu.test.intgfanniemae.com': {
    loginUrl: 'https://ic1.mfrm.mfbu.test.intgfanniemae.com/api/?cdxRedirectPath=/',
    serverWithApiUrl: 'https://ic1.mfrm.mfbu.test.intgfanniemae.com/api/',
    redirectUri: '',
    env: 'TEST'
  },
  'mfrm.cdxms.acpt-etss.aws.fanniemae.com': {
    loginUrl: 'https://mfrm.cdxms.acpt-etss.aws.fanniemae.com/api/?cdxRedirectPath=/',
    serverWithApiUrl: 'https://mfrm.cdxms.acpt-etss.aws.fanniemae.com/api/',
    redirectUri: '',
    env: 'ACPT'
  },
  'ic1.mfrm.mfbu.acpt.intgfanniemae.com': {
    loginUrl: 'https://ic1.mfrm.mfbu.acpt.intgfanniemae.com/api/?cdxRedirectPath=/',
    serverWithApiUrl: 'https://ic1.mfrm.mfbu.acpt.intgfanniemae.com/api/',
    redirectUri: '',
    env: 'ACPT'
  },
  'mfrm.acptfanniemae.com' : {
    loginUrl: 'https://mfrm.acptfanniemae.com/api/?cdxRedirectPath=/',
    serverWithApiUrl: 'https://mfrm.acptfanniemae.com/api/',
    redirectUri: '',
    env: 'ACPT'
  }, 
  'mfrm.fanniemae.com' : {
    loginUrl: 'https://mfrm.fanniemae.com/api/?cdxRedirectPath=/',
    serverWithApiUrl: 'https://mfrm.fanniemae.com/api/',
    redirectUri: '',
    env: 'PROD'
  }

};

export function buildEnvironment(production: boolean) {
  const host = window.location.hostname;
  const config = apiEndpoints[host] ?? apiEndpoints['localhost'];
  const appConfig = applicationUrls[host] ?? applicationUrls.localhost;

  return {
    production,
    unexpectedError: 'An unexpected error has occurred. Please try again after sometime. If the issue still persists, please contact Support for assistance.',
    apiBaseUrl: config.serverWithApiUrl.replace(/\/$/, ''),
    loginUrl: config.loginUrl,
    redirectUri: config.redirectUri,
    env: config.env,
    internalLogoutUrl: appConfig?.LogoutUrlInternal ?? '',
    externalLogoutUrl: appConfig?.LogoutUrlExternal ?? ''
  };
}

